import { KitDocumentoModalForm } from "./KitDocumentoModalForm"


const KitDocumentoModalFormWrapper = () => {
    return (<KitDocumentoModalForm />)
}

export {KitDocumentoModalFormWrapper}